import type { ComponentProps } from 'react';
import { AdvancedFilterTextInput as BaseAdvancedFilterTextInput } from '@tanium/react-advanced-filters';

type AdvancedFilterTextInputProps = ComponentProps<typeof BaseAdvancedFilterTextInput>;

export const AdvancedFilterTextInput = ({ style, ...rest }: AdvancedFilterTextInputProps): JSX.Element => (
  <BaseAdvancedFilterTextInput
    {...rest}
    style={{ height: 30, ...style }}
  />
);
